import SignupV2Wrapper from "../MultiSectionSignup/signupV2Wrapper";
import { useLoginSuccess } from "../Hook/useLoginSuccess";

const SignUpPageWrapper = () => {
    useLoginSuccess();
    return <SignupV2Wrapper/>
}

export default SignUpPageWrapper;
